<!--
 * @Author: your name
 * @Date: 2020-10-16 16:50:11
 * @LastEditTime: 2020-10-29 09:26:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/personal/common/work-company.vue
-->
<template>
  <div class="company-detail" style="background:#fff; ">
    <lay-out>
      <Row class="mem-tabs" style="background:#fafafa;" type="flex">
        <div
          v-for="(item, index) in tablist"
          :key="index"
          class="tab-item cursor"
          :class="activeTab === item.value ? ['active'] : ''"
          @click="handleTabChange(item)"
        >
          <span>{{ item.key }}</span>
        </div>
      </Row>

      <div v-if="pageLoading" class="loading" style="margin-top:120px">
        <div class="align-center">
          <img style="width:100px;" src="@/assets/new-global.gif" alt="" />
        </div>
      </div>

      <div
        class="company-view"
        v-if="
          !pageLoading && companyDetail && !isCompanyEdit && !isWorkPositionAdd
        "
      >
        <div class="back">
          <Button @click="goBack" type="primary" size="small">返回</Button>
        </div>
        <div class="name">
          <Row
            style="margin:0px; padding:0px"
            type="flex"
            justify="center"
            align="bottom"
          >
            <Col style="font-size:0px;padding:0px">
              <img
                v-if="!companyDetail.avatarFile"
                class="name-img"
                src="https://oss.zhulogic.com/planImage/fa/877_dir/5WKBaPrpdAWtkHiEjjS4HjyGrKzdXPfh75.png"
                alt=""
              />
              <img
                v-else
                class="name-img"
                :src="ossPrefix + companyDetail.avatarFile.key"
                alt=""
              />
            </Col>
            <Col class="name-name-view">
              <span class="name-view">{{ companyDetail.company }}</span>
            </Col>
          </Row>
        </div>

        <div>
          <div class="name-title">
            <span class="name-title-tag"></span>
            <span class="name-title-name">公司信息</span>
            <Button
              style="margin-left:84%;"
              @click="isCompanyEdit = true"
              size="small"
              >编辑</Button
            >
          </div>

          <div class="name-contont">
            <p>
              官网：<a>{{ companyDetail.website || '暂无' }}</a>
            </p>
            <p>手机号： {{ companyDetail.phone || '暂无' }}</p>
            <p>邮箱： {{ companyDetail.email || '暂无' }}</p>
            <p v-if="getAddress(companyDetail.locationId)">
              <!-- {{ getAddress(companyDetail.locationId) }} -->
              工作地址： {{ companyDetail.detailAddress | address }}
            </p>
            <p v-else>
              工作地址：暂无地址
            </p>
          </div>

          <div class="name-title">
            <span class="name-title-tag"></span>
            <span class="name-title-name">公司介绍</span>
          </div>

          <div class="name-contont">
            <p style="width:60%">
              {{ companyDetail.description || '还没有公司介绍哦！' }}
            </p>
          </div>

          <div class="name-title">
            <span class="name-title-tag"></span>
            <span class="name-title-name">公司项目</span>
          </div>

          <div
            v-if="
              companyDetail.projectFileList &&
                companyDetail.projectFileList.length > 0
            "
            class="name-contont"
            style="margin-bottom-25px"
          >
            <Row :gutter="25">
              <Col
                span="6"
                :key="index"
                v-for="(item, index) in companyDetail.projectFileList"
                class="name-contont-img"
              >
                <img :src="ossPrefix + item.key" alt="" />
              </Col>
            </Row>
          </div>
          <div v-else class="name-contont" style="margin-bottom-25px">
            <p>还没有上传公司项目</p>
          </div>

          <div class="name-title">
            <span class="name-title-tag"></span>
            <span class="name-title-name">招聘职位</span>
            <Button
              @click="addPositionHandle"
              style="margin-left:80%;"
              size="small"
              >添加职位</Button
            >
          </div>

          <div
            class="name-contont"
            v-for="(item, index) in companyDetail.positionList"
            v-if="
              companyDetail.positionList &&
                companyDetail.positionList.length > 0
            "
          >
            <Row class="prefab" :gutter="30">
              <Col span="18" class="left">
                <Row :gutter="10" class="prefab-left-main">
                  <Col span="10" class="title">{{ item.name }}</Col>
                  <Col style="text-align:right" span="12" class="des"
                    >{{ item.salaryDisplay }} / {{ item.experienceDisplay }} /
                    {{ item.educationDisplay }}</Col
                  >
                  <Col span="2" style="text-align:right"
                    ><span
                      class="loading"
                      :class="item.status == '0' ? 'loading-stop' : ''"
                      >{{ item.status == '0' ? '暂停' : '在招' }}</span
                    ></Col
                  >
                </Row>
              </Col>
              <Col span="6" style="text-align:right">
                <Button
                  @click="deletePosition(item)"
                  v-if="item.status == '0'"
                  type="text"
                >
                  <i
                    style="color: #E56A69;font-size: 18px;vertical-align: middle;margin-right: 1px;"
                    class="iconfont icon-shanchu"
                  ></i>
                  <span style="color: #E56A69;">删除</span>
                </Button>
                <Button type="text">
                  <i
                    style="color:#576B95;font-size: 18px;vertical-align: middle;margin-right: 1px;"
                    class="iconfont icon-iceditdefault"
                  ></i>
                  <span style="color: #576B95;" @click="editWorkPosition(item)"
                    >编辑</span
                  >
                </Button>
              </Col>
            </Row>

            <div class="position-cube">
              <p class="title">职位内容</p>
              <p style="font-size: 14px;font-weight: 400;color: #666666;">
                {{ item.description || '暂无职位内容' }}
              </p>
            </div>

            <div class="position-cube">
              <p class="title">任职要求</p>
              <p style="font-size: 14px;font-weight: 400;color: #666666;">
                {{ item.requirements || '暂无职位要求' }}
              </p>
            </div>

            <div class="position-cube">
              <p class="title">工作地址</p>
              <p style="font-size: 14px;font-weight: 400;color: #666666;">
                <!-- {{ getAddress(item.locationId) }} -->
                {{ item.detailAddress | address }}
              </p>
            </div>
          </div>

          <div v-else class="name-contont">
            <p>暂无招聘职位</p>
          </div>
        </div>
      </div>

      <work-company-edit
        @cencelCompanyHandle="cencelCompanyHandle"
        @editCompanySuccess="editCompanySuccess"
        v-if="isCompanyEdit"
        :companyDetail="companyDetail"
      ></work-company-edit>
      <work-position-add
        @cencelWorkAdd="cencelWorkAdd"
        @editCompanySuccess="editCompanySuccess"
        :editWorkPositionDetail="editWorkPositionDetail"
        v-if="isWorkPositionAdd"
      ></work-position-add>
    </lay-out>
  </div>
</template>

<script>
import axios from 'axios'
import { getAddress } from '@/utils'
import workCompanyEdit from './work-company-edit'
import workPositionAdd from './work-position-add'
import LayOut from './layout'
export default {
  name: '',
  data() {
    return {
      getAddress: getAddress,
      activeTab: 1,
      pageLoading: false,
      isCompanyEdit: false,
      companyDetail: null,
      isWorkPositionAdd: false,
      tablist: [{ key: '公司招聘', value: 1 }, { key: '个人简历', value: 2 }],
    }
  },
  components: { workCompanyEdit, LayOut, workPositionAdd },
  methods: {
    handleTabChange(item) {
      this.activeTab = item.value
      if (item.value == 1) {
        this.$router.push({ path: '/my-work' })
      } else if (item.value == 2) {
        this.$router.push({ path: '/my-work?index=2' })
      }
    },
    goBack() {
      this.$router.push({ path: '/my-work' })
    },
    // 公司详情
    getCompanyDetail() {
      if (!this.$route.query.id) return
      this.pageLoading = true
      axios
        .get(`/designer_api/job/company/${this.$route.query.id}`)
        .then((res) => {
          this.companyDetail = res
          this.isCompanyEdit = false
          this.isWorkPositionAdd = false
          this.pageLoading = false
        })
        .catch((err) => {
          // 报错调到编辑页面
          this.isCompanyEdit = true
          this.pageLoading = false
        })
    },
    addPositionHandle() {
      this.editWorkPositionDetail = null
      this.isWorkPositionAdd = true
    },
    cencelCompanyHandle() {
      this.isCompanyEdit = false
    },
    // 公司编辑成功
    editCompanySuccess() {
      this.getCompanyDetail()
    },
    cencelWorkAdd() {
      this.isWorkPositionAdd = false
    },

    // 打开编辑
    editWorkPosition(item) {
      this.editWorkPositionDetail = item
      this.isWorkPositionAdd = true
    },
    //删除职位
    deletePosition(item) {
      this.$Modal.confirm({
        title: '删除提示',
        content: '<p>确定要删除该职位吗？</p>',
        onOk: () => {
          axios
            .delete(
              `/designer_api/job/company/${this.$route.query.id}/position/${
                item.id
              }`
            )
            .then((res) => {
              this.$Message.success('删除成功!')
              this.getCompanyDetail()
            })
        },
      })
    },
  },
  created() {
    this.getCompanyDetail()
  },
  watch: {
    $route: function() {
      this.getCompanyDetail()
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .personal-layout {
  width: 955px;
}
.company-detail {
  .company-view {
    padding: 25px 40px;
    .back {
      margin-bottom: 5px;
      text-align: right;
    }
    .name {
      font-size: 0px;
      .name-img {
        background: #f3f5f9;
        border: 1px solid #efefef;
        width: 80px;
        height: 80px;
      }
      .name-name-view {
        height: 60px;
        background: #fffbfa;
        line-height: 60px;
        width: 90%;
        .name-view {
          font-size: 20px;
          font-weight: bold;
          color: #373737;
          display: inline-block;
          margin-left: 20px;
        }
      }
    }
    .name-title {
      margin-top: 50px;
      margin-bottom: 30px;
      .name-title-tag {
        display: inline-block;
        width: 3px;
        background: #e56a69;
        margin-right: 8px;
        vertical-align: middle;
        height: 14px;
        margin-top: -5px;
      }
      .name-title-name {
        font-size: 16px;
        font-weight: bold;
        color: #373737;
      }
    }
    .name-contont {
      margin-bottom: 50px;
      > p {
        font-size: 14px;
        font-weight: 500;
        color: #5b6066;
        margin-top: 5px;
      }
      /deep/ .name-contont-img {
        height: 120px;
        overflow: hidden;
        font-size: 0px;
        margin-bottom: 25px;
        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .prefab {
        .left {
          background: #f9fafc;
          height: 38px;
          padding: 8px;
        }
        .prefab-left-main .title {
          font-size: 16px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #373737;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
        }
        .prefab-left-main .des {
          font-size: 14px;
          font-weight: 500;
          color: #313131;
        }
        .prefab-left-main .loading {
          display: inline-block;
          width: 32px;
          height: 18px;
          background: #e9f2fc;
          border-radius: 2px;
          line-height: 18px;
          text-align: center;
          font-size: 12px;
          font-weight: 400;
          color: #61a1ec;
        }
        .prefab-left-main .loading-stop {
          background: #fffbfa;
          color: #e56a69;
        }
      }
    }

    .position-cube {
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #373737;
        margin-top: 30px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
